import { axiosInstance } from '@src/configs/axios.configs';
import { IResponse } from '@src/interfaces/axios.interfaces';

import { IUserProfileResponse } from '../types/profile.types';

export const profileService = {
  getUserProfile: (): IResponse<IUserProfileResponse> =>
    axiosInstance('api/users/profile'),
};
